export { default } from './RegisterDevice';
